import request from "@/core/utils/request";

export async function queryPost(params, url) {
  return request(url, {
    method: "post",
    headers: { "Content-Type": "application/json" },
    data: params
  });
}
export async function query(url) {
  return request(url);
}
export async function queryParams(params, url) {
  return request(url, { params });
}
export async function create(params, url) {
  return request(url, {
    method: "post",
    data: params
  });
}
export async function update(params, url) {
  return request(url, {
    method: "post",
    headers: { "Content-Type": "application/json" },
    data: params
  });
}
export async function remove(params, url) {
  return request(url, {
    method: "post",
    headers: { "Content-Type": "application/json" },
    data: params
  });
}

export async function upload(data) {
  const formData = new FormData();
  if (data.file instanceof Blob) {
    formData.append("file", data.file, data.file.name);
  } else {
    formData.append("file", data.file);
  }
  return request("/app/file/upload", {
    method: "post",
    data: formData
  });
}
